import {
    LOADING_DATA_PROYECTOS,
    SET_DATA_PROYECTOS,
    SET_ERROR_PROYECTOS
} from '../types'

const initialState = {
    loadingproyectos: false,
    proyectos: [],
    message: '',
    error: ''
}


export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_DATA_PROYECTOS:
            return {
                ...state,
                loadingproyectos: true
            }
        case SET_DATA_PROYECTOS:
            return {
                loadingproyectos: false,
                ...action.payload
            }
        case SET_ERROR_PROYECTOS:
            return {
                loadingproyectos: false,
                ...action.payload
            }
        default: return state
    }
}